import { useMemo } from 'react'
import { OrderStepButtonsDefaultBaseComponent, OrderStepButtonsNewStyleBaseComponent } from '../../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent'
import { OrderStepButtonsBase, OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types'
import { SellDownloadButtonPDF, SellDownloadPdfTemplateButton, SellPdfPreview } from '../../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderSellLayout/SellButtons'
import useTwinTranslation from '../../../../../../../../../../../utils/hooks/useTwinTranslation'

const SellTicketFinishedStepButtons: React.FC<OrderStepButtonsBaseComponentProps> = ({ data, onSubmit, ...rest }) => {
    return (
        <div className='flex items-center relative gap-5 flex-wrap-reverse'>
            <OrderStepButtonsDefaultBaseComponent {...{ data, onSubmit, hookFunction: useSellTicketFinishedStepButtonsLogic, ...rest }} className='mr-8' />
        </div>
    )
}

const useSellTicketFinishedStepButtonsLogic = ({ data }: OrderStepButtonsBaseComponentProps) => {
    const { t } = useTwinTranslation()
    const name = 'sell_ticket_finished_step_buttons'
    const Order = data?.header
    const defaultButtons = [{ "id": "previewSellTicket" }, { "id": "downloadSellTicket" }, { "id": "quickAccess" }, { "id": "createWorkSheet" }, { "id": "viewWorkSheet" }, { "id": "sellTicketRefund" }]

    const sellTicketPDFPreviewText = t('previewPdf', 'Previsualizar PDF')
    const sellTicketDownloadPDFTemplateText = t('downloadPdfTemplate', 'Descargar plantilla PDF')
    const sellTicketDownloadPDFText = t('downloadPdf', 'Descargar PDF')
    const ButtonComponents: OrderStepButtonsBase = useMemo(() => {
        return {
            previewSellTicket: {
                component: SellPdfPreview,
                extraProps: {
                    title: sellTicketPDFPreviewText,
                    id: 'previewSellTicket',
                    Order,
                    typeTemplate: 'ticketPDF'
                }
            },
            downloadSellTicketTemplate: {
                component: SellDownloadPdfTemplateButton,
                extraProps: {
                    title: sellTicketDownloadPDFTemplateText,
                    id: 'downloadSellTicketTemplate',
                    Order,
                    typeTemplate: 'ticketPDF',
                }
            },
            downloadSellTicket: {
                component: SellDownloadButtonPDF,
                extraProps: {
                    title: sellTicketDownloadPDFText,
                    id: 'downloadSellTicket',
                    Order,
                    typeTemplate: 'ticketPDF',
                }
            },
        }
    }, [Order, sellTicketDownloadPDFTemplateText, sellTicketDownloadPDFText, sellTicketPDFPreviewText])

    return { name, ButtonComponents, defaultButtons }
}

export const SellTicketFinishedStepButtonsNew: React.FC<OrderStepButtonsBaseComponentProps> = ({ data, onSubmit, ...rest }) => {
    return (
        <div className='flex items-center relative gap-5 flex-wrap-reverse'>
            <OrderStepButtonsNewStyleBaseComponent {...{ data, onSubmit, hookFunction: useSellTicketFinishedStepButtonsLogic, ...rest }} className='mr-8' />
        </div>
    )
}

export default SellTicketFinishedStepButtons